import { Post } from './Post';

const HelloWorld = {
  title: "Hello world!",
  subtitle: "",
  path: "/post/hello-world",
  postedAt: new Date(Date.parse("Sat, 03 Mar 2025 03:44:57 EST")),
  body: `Hi, I'm Jake Kinsella. I'm a senior software engineer + tech lead blogging about my work at ChaosSearch, my personal projects, and chronicling my journey in starting my own company.`,
} satisfies Post;

export default HelloWorld;
